import { render, staticRenderFns } from "./statisFilter.vue?vue&type=template&id=a66b238a&scoped=true&"
import script from "./statisFilter.vue?vue&type=script&lang=js&"
export * from "./statisFilter.vue?vue&type=script&lang=js&"
import style0 from "./statisFilter.vue?vue&type=style&index=0&id=a66b238a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66b238a",
  null
  
)

export default component.exports